/** * * Asynchronously loads the component for
Home Phone Checkout
* */ import { lazyLoad } from "utils/loadable";
export const HomePhoneCheckout = lazyLoad(
  () => import("./index"),
  (module) => module.HomePhoneCheckout
);
